<div class="rx-card">
	<div class="rx-card-title">
		<div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--align-center">
			<div>{{ 'ApplianceDetails.ApplianceDetailsTitle' | translate }}:</div>
		</div>
	</div>

	<form class="rx-card-body rx-app-flex-container-row" [formGroup]="form">
		<ng-container *ngIf="applianceFieldsVisibility$ | async as fieldsVisibility">
			<!-- Arch Title Row — visible when template allows upperLowerCard -->
			<div
				*ngIf="fieldsVisibility.upperLowerCard"
				class="rx-title-row arch-title rx-app-flex--full rx-app-flex-container-column"
			>
				<div class="rx-title-row arch-title smallTitle rx-app-flex--full rx-app-flex-container-column">
					<small>{{ 'ApplianceDetails.Arch' | translate }}</small>
				</div>

				<!-- Selectors Row -->
				<div class="selectors-row rx-app-flex--full rx-app-flex-container-column">
					<!-- Upper and Lower Arch Toggle -->
					<div class="selectors-row-child rx-app-flex--full rx-app-flex-container-row rx-app-flex-container-row--align-center">
						<tlk-slide-toggle
							class="toggle"
							[formControl]="isUpperControl"
							name="isUpperControl"
							[id]="'isUpper'"
							labelPosition="left"
							[isDisabled]="(isApplianceUpperReadonly$ | async) || (isReadonly$ | async)"
						>{{ 'ApplianceDetails.UpperArch' | translate }}</tlk-slide-toggle>

						<tlk-slide-toggle
							class="toggle"
							[formControl]="isLowerControl"
							name="isLowerControl"
							[id]="'isLower'"
							labelPosition="left"
							[isDisabled]="(isApplianceLowerReadonly$ | async) || (isReadonly$ | async)"
						>{{ 'ApplianceDetails.LowerArch' | translate }}</tlk-slide-toggle>
					</div>
				</div>
			</div>
			<!-- Appliance Type Selector -->
			<div
				*ngIf="fieldsVisibility.applianceType"
				class="rx-title-row arch-title rx-app-flex--full rx-app-flex-container-column"
			>
				<div class="sides rx-app-flex-container-column">
					<rx-select
						[id]="'applianceType'"
						[label]="'ApplianceDetails.Type' | translate"
						[formControl]="applianceTypeControl"
						[options]="applianceTypes$ | async"
						[isDisabled]="isReadonly$ | async"
						[isCancellable]="true"
						name="applianceTypeControl"
					>
					</rx-select>
				</div>
			</div>
		</ng-container>
	</form>
</div>
